import React from 'react';
import { JourneyBackBar } from '@components/StudentJourney/week/JourneyBackBar';
import { Mascot, ClassicDarkScope } from '@components/StudentJourney';
import StudentSkillProfilePage from '@pages/StudentPortal/StudentSkillProfile/StudentSkillProfilePage';

/**
 * Journey wrap for the Skill Profile. The Skill Profile page is shared
 * with Cohort 1 and carries its own verified credential layouts, project showcase,
 * and animated Spider Skill Chart.
 *
 * For Cohort 2+ students, the coding-dog introduces the Skill Profile so it
 * matches the Journey trail experience seamlessly.
 * ClassicDarkScope re-supplies the .student-dark ancestor needed for dark styling.
 */
const JourneySkillProfile: React.FC = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
    <JourneyBackBar to="/student/journey" label="Back to the trail" />

    <div className="sp-lab-intro">
      <Mascot name="poseCoding" size={92} move="bob" className="sp-lab-intro__mascot" />
      <div className="sp-lab-intro__body">
        <div className="sp-lab-intro__kicker">Fellow Skill Profile</div>
        <h2 className="sp-lab-intro__title">Verified Credentials &amp; Competency Matrix</h2>
        <p className="sp-lab-intro__text">
          Your official fellowship credential, authenticated project showcase, and 5-core
          competency spider radar evaluated by your mentors and Demo Day judges.
        </p>
      </div>
    </div>

    <ClassicDarkScope>
      <StudentSkillProfilePage />
    </ClassicDarkScope>
  </div>
);

export default JourneySkillProfile;
